import styleSheetsRequestCache from './styleSheetsRequestCache';

export default async function resolveStylesheetsContent(stylesheets) {
	try {
		const errorText = `<title>Error</title>`;
		const responses = await Promise.all(
			stylesheets.map(stylesheet => {
				if (styleSheetsRequestCache.has(stylesheet)) {
					return styleSheetsRequestCache.get(stylesheet);
				}
				const request = fetch(stylesheet);
				styleSheetsRequestCache.set(stylesheet, request);
				return request;
			})
		);
		let text = await Promise.all(
			responses.map(response => (response.clone ? response.clone() : response).text())
		);
		text = text.filter(t => !t.includes(errorText));
		return text.join(' ');
	} catch (e) {
		return '';
	}
}
